import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../Redux/store";
import { setPrevLocation, setShowBackButton } from "../Redux/slices/GlobalSlice";

interface useKaziNavigateProps {}

export const useKaziNavigate = () => {
    /* ******************** Hooks ******************** */
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const userType = useAppSelector( state => state.Global.userType)
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    //TODO: Use url constants
    const navigateToProfile = () => {
        navigate(`/profile/${userType}`)
    }
    const navigateToSettings = () => {
        navigate(`/settings`)
    }
    const navigateToTalent = (locator: string) => {
        navigate(`/profile/talent/${locator}`)
    }
    const navigateToClient = (locator: string) => {
        navigate(`/profile/client/${locator}`)
    }
    const navigateToMessages = (locator: string, name?: string) => {
        navigate(`/messages?conversation=${locator}${name ? `&name=${name}` : ''}`)
    }
    const navigateToUpgrade = () => {
        navigate('/settings/membership?mode=edit')
    }
    const navigateToJob = (locator: string) => {
        navigate(`/job-postings/posting/${locator}`)
    }
    const navigateWithBack = (link: string) => {
        dispatch(setPrevLocation(window.location.pathname));
        dispatch(setShowBackButton(true));
        navigate(link)
    }
    /* *****
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return {
        navigateToClient,
        navigateToTalent,
        navigateToMessages,
        navigateWithBack,
        navigateToProfile,
        navigateToUpgrade,
        navigateToSettings,
        navigateToJob
    }
}
